export default __webpack_public_path__ + "static/media/icon_guide_delete.5afb90e1.svg";